import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=20676164&"
import script from "./TransferFunds.vue?vue&type=script&lang=js&"
export * from "./TransferFunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports